import React, { useState } from 'react';
import { NSInput, NSLabel, NSModal } from 'bricks';
import { IReportBuilderReport } from 'views/ReportBuilder/constants.js';
import { useCreateReportBuilderTemplate } from 'views/ReportBuilder/hooks';
import { useParams } from 'react-router-dom';
import ReportListItem from '../GenerateReportModal/ReportListItem';

export interface ISaveTemplateModalProps {
    orgId: string;
    newReports: Array<IReportBuilderReport>;
    isOpen: boolean;
    toggle: () => void;
}

const SaveTemplateModal = ({
    orgId, newReports, toggle, isOpen,
}: ISaveTemplateModalProps) => {
    const [templateName, setTemplateName] = useState<string>('');
    const { dealId: dealIdString } = useParams<{ dealId: string; proFormaId: string }>();
    const dealId = Number(dealIdString);

    const handleNameChange = (templateNameInput: string) => {
        setTemplateName(templateNameInput);
    };

    const { mutate: createReportBuilderTemplate, isPending: isSavingReport } = useCreateReportBuilderTemplate();

    const saveNewTemplate = () => {
        createReportBuilderTemplate({
            dealId,
            postData: {
                orgId,
                templateName,
                reportBuilderReports: newReports.map(report => ({
                    reportType: report.reportType,
                    metaData: {
                        savedReportId: report.savedReportId,
                        savedReportName: report.savedReportName,
                        savedReportType: report.savedReportType,
                        boeScenarioIds: report.selectedBOEScenarioIds,
                        boeScenarioNames: report.selectedBOEScenarioNames,
                        proFormaId: report.selectedProFormaId,
                        proFormaName: report.selectedProFormaName,
                        dealAttributes: report.selectedDealAttributes,
                        includePrintedOnDate: report.includePrintedOnDate,
                        includeTargetReturns: report.includeTargetReturns,
                    },
                })),
            },
        });
        toggle();
    };

    return (
        <NSModal
            toggle={toggle}
            isOpen={isOpen}
            modalHeaderClassName="bg-primary text-white"
            modalHeaderText="Save template"
            footerButtonOutline={false}
            modalFooterButtonColor="primary"
            modalFooterButtonText="Save template"
            modalFooterButtonFunction={saveNewTemplate}
            modalFooterIsButtonFunctionDisabled={!templateName}
            modalFooterButtonIsLoading={isSavingReport}
        >
            <NSLabel>Save new custom template as:</NSLabel>
            <NSInput
                dataTestId="template-name-input"
                type="text"
                name="template name"
                value={templateName}
                onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                    handleNameChange(event.target.value);
                }}
            />
            <NSLabel className="mt-1">The following report sections will be saved:</NSLabel>
            {newReports.map((report, index) => (
                <ReportListItem key={report.reportType} report={report} index={index} />
            ))}
        </NSModal>
    );
};

export default SaveTemplateModal;
